import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import App from './components/App';
import { Provider } from 'react-redux';
import configureStore from './store';
import './i18n';
import config from './config';

import 'react-datepicker/dist/react-datepicker.css';
import './assets/sass/app.scss';
import { VariablesProvider } from './context/variables';
import { PermissionProvider } from './context/permisson';

const store = configureStore();
const rootEl = document.getElementById('root');

Sentry.init({
  dsn: config.SENTRY_DNS,
  autoSessionTracking: true,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 0,
});

const root = ReactDOM.createRoot(rootEl);
const render = Component =>
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <PermissionProvider>
          <VariablesProvider>
            <Component />
          </VariablesProvider>
        </PermissionProvider>
      </Provider>
    </React.StrictMode>
  );

render(App);

// Hot Module Replacement (HMR)
if (module.hot) {
  module.hot.accept('./components/App', () => {
    render(App);
  });
}
